import { RuntimeMistakeReviewScreen } from '@/features/unified-learning/runtime/screens/RuntimeMistakeReviewScreen';

export default function LearnMistakeReviewRoute() {
  return <RuntimeMistakeReviewScreen runtimeBase="/learn/path" />;
}
